import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { normalizeRole } from '@/shared/utils/role'
import { getCurrentPlanForUser } from '../services/memberPlanService'

type FreemiumPlanStatus = {
  isFreemium: boolean
  loading: boolean
  error: string | null
  planId: string | null
}

export function useFreemiumPlanStatus(): FreemiumPlanStatus {
  const { user, profile } = useAuth()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [planId, setPlanId] = React.useState<string | null>(null)
  const roleRaw = String(
    profile?.role ||
      (user as any)?.user_metadata?.role ||
      (user as any)?.app_metadata?.role ||
      '',
  ).toLowerCase()
  const role = normalizeRole(roleRaw)
  const isMember = role === 'member'

  const load = React.useCallback(async () => {
    if (!user?.id || !isMember) {
      setPlanId(null)
      setLoading(false)
      setError(null)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const { plan, access, subscription } = await getCurrentPlanForUser(user.id)
      const effectivePlanId =
        access?.effectivePlanId ||
        plan?.id ||
        (subscription as any)?.plan_id ||
        null
      setPlanId(effectivePlanId ? String(effectivePlanId).trim() : null)
    } catch (e: any) {
      setPlanId(null)
      setError(e?.message || 'Falha ao carregar plano do usuario')
    } finally {
      setLoading(false)
    }
  }, [isMember, user?.id])

  React.useEffect(() => {
    load()
  }, [load])

  const isFreemium = isMember && String(planId || '').toLowerCase() === 'trial_7d'

  return {
    isFreemium,
    loading,
    error,
    planId,
  }
}
